import { render, staticRenderFns } from "./storeCard.tpl.vue?vue&type=template&id=6ea3f502&scoped=true&lang=html&name=StoreCard&"
import script from "./storeCard.js?vue&type=script&lang=js&"
export * from "./storeCard.js?vue&type=script&lang=js&"
import style0 from "./storeCard.styl?vue&type=style&index=0&id=6ea3f502&lang=stylus&scoped=true&"
import style1 from "./reset-vant.styl?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea3f502",
  null
  
)

export default component.exports